import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../service/api_service';
import { ColumnApi, ColumnGroup, GridApi } from 'ag-grid-community';
import { Subscription } from 'rxjs';
import * as $ from 'jquery';
import { ToastrService } from 'ngx-toastr';


@Component({
  selector: 'app-screenmapping',
  template: require('./screenmapping.component.html'),
  styles: []
})
export class ScreenMappingComponent implements OnInit {
  api: GridApi;
  columnApi: ColumnApi;
  api1: GridApi;
  columnApi1: ColumnApi;
  expDetails: any;
  private columnDefs;
  private columnDefs1;
  ScreenData: any[];
  ClientTypeData: any[];
  menuID: any = [];
  ClientTypeID: any;
  private rowHeight;
  private rowHeight1;
  defaultColDefine;
  defaultColDefine1;
  private gridColumnApi;
  private gridColumnApi1;
  private detailCellRendererParams;
  busy: Subscription;
  token: any;
  checked: any;
  static parameters = [ApiService, ToastrService]

  constructor(private apiService: ApiService, private toastr: ToastrService) {

    let parent = this;
    this.columnDefs1 = [
      // { headerName: 'S.No.', field: 'sno', valueGetter: "node.rowIndex + 1", width: 90 },
      {
        headerName: 'Client Type', field: "ClientTypeDesc", filter: 'agTextColumnFilter', width: 300
        // , cellRenderer: function (params) {
        //   var eDiv = document.createElement('div');
        //   eDiv.innerHTML = `
        //       <div class="grid_actions">
        //           <span class=" viewBtn">`+ params.data.ClientTypeDesc + `</span>
        //       </div>
        //       `;
        //   var viewButton = eDiv.querySelectorAll('.viewBtn')[0];
        //   viewButton.addEventListener('click', function () {
        //     parent.getScreenName(params.data);
        //   });
        //   return eDiv;
        // }
      },
    ];
    this.checked = 0;

    this.columnDefs = [
      // { headerName: 'S.No.', field: 'sno', valueGetter: "node.rowIndex + 1", width: 90 },
      {
        headerName: '', field: 'status', width: 50,
        headerComponentParams: {
          template:
            '<div class="ag-cell-label-container" role="presentation">' +
            '  <input type="checkbox" class="header-check-box-check">' +
            '</div>'
        }
        , cellRenderer: function (params) {
          var input = document.createElement('input');
          input.type = "checkbox";
          input.id = 'CHECK-' + params.data.ID;
          params.value = !params.value;
          input.checked = params.value;
          if (input.checked == true) {
            let index = parent.menuID.map(item => item._ID).indexOf(params.data.ID);
            if (index != -1) {
              parent.menuID.splice(index, 1);
            }
            parent.menuID.push({ "_ID": params.data.ID, "check": true });
          } else {
            let index = parent.menuID.map(item => item._ID).indexOf(params.data.ID);
            if (index != -1) {
              parent.menuID.splice(index, 1);
            }
            parent.menuID.push({ "_ID": params.data.ID, "check": false });
          }

          if (parent.menuID.length == parent.ScreenData.length) {
            let index = parent.menuID.map(item => item.check).indexOf(false);
            if (index != -1) {
              $('.header-check-box-check').prop("checked", false);
            } else {
              $('.header-check-box-check').prop("checked", true);
            }
          }
          input.addEventListener('click', function (event) {
            params.value = !params.value;
            params.value = !(params.node.data.status);
            params.node.data.status = Number(params.value);
            if (input.checked == true) {
              let index = parent.menuID.map(item => item._ID).indexOf(params.data.ID);
              if (index != -1) {
                parent.menuID.splice(index, 1);
              }
              parent.menuID.push({ "_ID": params.data.ID, "check": true });
            } else {
              let index = parent.menuID.map(item => item._ID).indexOf(params.data.ID);
              if (index != -1) {
                parent.menuID.splice(index, 1);
              }
              parent.menuID.push({ "_ID": params.data.ID, "check": false });
            }

            if (parent.menuID.length == parent.ScreenData.length) {
              let index = parent.menuID.map(item => item.check).indexOf(false);
              if (index != -1) {
                $('.header-check-box-check').prop("checked", false);
              } else {
                $('.header-check-box-check').prop("checked", true);
              }
            }

          });
          return input;
        }
      },
      {
        headerName: 'Screen', field: "Name", filter: 'agTextColumnFilter', width: 600
      },
    ];
    this.defaultColDefine = { resizable: true };
    this.rowHeight = 50;
    this.defaultColDefine1 = { resizable: true };
    this.rowHeight1 = 50;

  }


  ngOnInit() {
    this.token = JSON.parse(sessionStorage.getItem("currentUser"));
    this.ClientTypeData = [];
    this.ScreenData = [];
    this.GetClientType();
    var parent = this;
    $(document).ready(function () {
      $('.header-check-box-check').click(function () {
        var val = $(this).is(':checked');
        parent.ScreenData.forEach((element, i) => {
          $('#CHECK-' + element.ID).prop('checked', val);
          if (val == true) {
            let index = parent.menuID.map(item => item._ID).indexOf(element.ID);
            if (index != -1) {
              parent.menuID.splice(index, 1);
            }
            parent.menuID.push({ "_ID": element.ID, "check": true });
            parent.ScreenData[i].status = 0;

            $('.header-check-box-check').prop("checked", true);
          } else {
            let index = parent.menuID.map(item => item._ID).indexOf(element.ID);
            if (index != -1) {
              parent.menuID.splice(index, 1);
            }
            parent.menuID.push({ "_ID": element.ID, "check": false });
            parent.ScreenData[i].status = 1;
            $('.header-check-box-check').prop("checked", false);

          }
        });
      });
    });
  }

  onGridReady = (params) => {
    this.api = params.api;
    this.gridColumnApi = params.columnApi;
    this.api.hideOverlay();
  }

  onGridReady1 = (params) => {
    this.api1 = params.api;
    this.gridColumnApi1 = params.columnApi;
    this.api1.hideOverlay();
  }



  onFilterTextBoxChanged() {
    this.api1.setQuickFilter(document.querySelector<HTMLInputElement>('#filter-text-box')!.value);
    this.api1.refreshCells();
  }

  GetClientType() {
    this.busy = this.apiService.GetClientType().subscribe((res: any) => {
      this.ClientTypeData = res.data;
      console.log('this.ClientTypeData', this.ClientTypeData)
    })
  }

  getScreenName(params) {
    this.ClientTypeID = params.data.ClientTypeID;
    this.busy = this.apiService.getScreenName({ clientTypeID: this.ClientTypeID }).subscribe((res: any) => {
      this.ScreenData = res.data;
      this.menuID = [];
      this.checked = 0;
      console.log('this.ScreenData', this.ScreenData)
      $('.header-check-box-check').prop("checked", false);
    })
  }

  InsertScreenMapping() {
    if (this.menuID.length == 0) {
      this.toastr.warning("Please Select Any One Screen Name");
      return false;
    }
    let token = JSON.parse(sessionStorage.getItem("currentUser"));
    let data = {
      menuID: this.menuID,
      ClientTypeID: this.ClientTypeID,
      token: token.id
    }
    this.busy = this.apiService.InsertScreenMapping(data).subscribe((res: any) => {
      this.toastr.success("Screen Mapped Successfully");
    })
  }

}
